import { Action } from 'redux';

import { QuickSwitch, QuickSwitchItem } from '../insight/config.insight.model';
import { DataFilterOptions } from '../performance-data/data-filter-options.pd.model';

export enum ActionType {
    PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT = 'PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT',
    PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT_RESULT = 'PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT_RESULT',
}

export interface LevelOptionSelectAction extends Action<ActionType> {
    opt: QuickSwitchItem;
}

export const levelOptionSelect = (
    opt: QuickSwitchItem,
): LevelOptionSelectAction => ({
    type: ActionType.PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT,
    opt,
});

export interface LevelOptionSelectResultAction extends LevelOptionSelectAction {
    quickSwitch?: QuickSwitch;
    filteredItems?: QuickSwitchItem[];
    canChangeActive?: boolean;
    initialDataFilterOpts?: DataFilterOptions;
}

export const levelOptionSelectResult = (
    quickSwitch?: QuickSwitch,
    filteredItems?: QuickSwitchItem[],
    opt?: QuickSwitchItem,
    canChangeActive?: boolean,
): LevelOptionSelectResultAction => ({
    type: ActionType.PERFORMANCE_INSIGHT__LEVEL_OPTION__SELECT_RESULT,
    quickSwitch,
    filteredItems,
    opt,
    canChangeActive,
});
